// extracted by mini-css-extract-plugin
var _1 = "Button__Button___pjOT_";
var _2 = "Button__clickable___yAxdK";
var _3 = "Button__disabled___lGiCT";
var _4 = "Button__primary___XMjvO";
var _5 = "Button__success___BMJCu";
var _6 = "Button__wiggle___i5l6x";
export { _1 as "Button", _2 as "clickable", _3 as "disabled", _4 as "primary", _5 as "success", _6 as "wiggle" }
